// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/core/transaction/v1/transaction.proto (package penumbra.core.transaction.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Any, proto3 } from "@bufbuild/protobuf";
import { BindingSignature, SpendAuthSignature } from "../../../crypto/decaf377_rdsa/v1/decaf377_rdsa_pb.js";
import { MerkleRoot, StateCommitment, StateCommitmentProof } from "../../../crypto/tct/v1/tct_pb.js";
import { Fee } from "../../component/fee/v1/fee_pb.js";
import { Clue } from "../../../crypto/decaf377_fmd/v1/decaf377_fmd_pb.js";
import { Note, Output, OutputPlan, OutputView, Spend, SpendPlan, SpendView } from "../../component/shielded_pool/v1/shielded_pool_pb.js";
import { BatchSwapOutputData, PositionClose, PositionOpen, PositionRewardClaim, PositionRewardClaimPlan, PositionWithdraw, PositionWithdrawPlan, Swap, SwapClaim, SwapClaimPlan, SwapClaimView, SwapPlan, SwapView } from "../../component/dex/v1/dex_pb.js";
import { Delegate, Undelegate, UndelegateClaim, UndelegateClaimPlan, ValidatorDefinition } from "../../component/stake/v1/stake_pb.js";
import { IbcRelay, Ics20Withdrawal } from "../../component/ibc/v1/ibc_pb.js";
import { CommunityPoolDeposit, CommunityPoolOutput, CommunityPoolSpend, DelegatorVote, DelegatorVotePlan, DelegatorVoteView, ProposalDepositClaim, ProposalSubmit, ProposalWithdraw, ValidatorVote } from "../../component/governance/v1/governance_pb.js";
import { ActionDutchAuctionEnd, ActionDutchAuctionSchedule, ActionDutchAuctionScheduleView, ActionDutchAuctionWithdraw, ActionDutchAuctionWithdrawPlan, ActionDutchAuctionWithdrawView } from "../../component/auction/v1/auction_pb.js";
import { Address, AddressView, PayloadKey } from "../../keys/v1/keys_pb.js";
import { AssetId, EstimatedPrice, Metadata } from "../../asset/v1/asset_pb.js";
import { EffectHash, TransactionId } from "../../txhash/v1/txhash_pb.js";
import { Nullifier } from "../../component/sct/v1/sct_pb.js";

/**
 * A Penumbra transaction.
 *
 * @generated from message penumbra.core.transaction.v1.Transaction
 */
export const Transaction = proto3.makeMessageType(
  "penumbra.core.transaction.v1.Transaction",
  () => [
    { no: 1, name: "body", kind: "message", T: TransactionBody },
    { no: 2, name: "binding_sig", kind: "message", T: BindingSignature },
    { no: 3, name: "anchor", kind: "message", T: MerkleRoot },
  ],
);

/**
 * The body of a transaction.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionBody
 */
export const TransactionBody = proto3.makeMessageType(
  "penumbra.core.transaction.v1.TransactionBody",
  () => [
    { no: 1, name: "actions", kind: "message", T: Action, repeated: true },
    { no: 2, name: "transaction_parameters", kind: "message", T: TransactionParameters },
    { no: 4, name: "detection_data", kind: "message", T: DetectionData },
    { no: 5, name: "memo", kind: "message", T: MemoCiphertext },
  ],
);

/**
 * The parameters determining if a transaction should be accepted by the chain.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionParameters
 */
export const TransactionParameters = proto3.makeMessageType(
  "penumbra.core.transaction.v1.TransactionParameters",
  () => [
    { no: 1, name: "expiry_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "chain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "fee", kind: "message", T: Fee },
  ],
);

/**
 * Detection data used by a detection server performing Fuzzy Message Detection.
 *
 * @generated from message penumbra.core.transaction.v1.DetectionData
 */
export const DetectionData = proto3.makeMessageType(
  "penumbra.core.transaction.v1.DetectionData",
  () => [
    { no: 4, name: "fmd_clues", kind: "message", T: Clue, repeated: true },
  ],
);

/**
 * A state change performed by a transaction.
 *
 * @generated from message penumbra.core.transaction.v1.Action
 */
export const Action = proto3.makeMessageType(
  "penumbra.core.transaction.v1.Action",
  () => [
    { no: 1, name: "spend", kind: "message", T: Spend, oneof: "action" },
    { no: 2, name: "output", kind: "message", T: Output, oneof: "action" },
    { no: 3, name: "swap", kind: "message", T: Swap, oneof: "action" },
    { no: 4, name: "swap_claim", kind: "message", T: SwapClaim, oneof: "action" },
    { no: 16, name: "validator_definition", kind: "message", T: ValidatorDefinition, oneof: "action" },
    { no: 17, name: "ibc_relay_action", kind: "message", T: IbcRelay, oneof: "action" },
    { no: 18, name: "proposal_submit", kind: "message", T: ProposalSubmit, oneof: "action" },
    { no: 19, name: "proposal_withdraw", kind: "message", T: ProposalWithdraw, oneof: "action" },
    { no: 20, name: "validator_vote", kind: "message", T: ValidatorVote, oneof: "action" },
    { no: 21, name: "delegator_vote", kind: "message", T: DelegatorVote, oneof: "action" },
    { no: 22, name: "proposal_deposit_claim", kind: "message", T: ProposalDepositClaim, oneof: "action" },
    { no: 30, name: "position_open", kind: "message", T: PositionOpen, oneof: "action" },
    { no: 31, name: "position_close", kind: "message", T: PositionClose, oneof: "action" },
    { no: 32, name: "position_withdraw", kind: "message", T: PositionWithdraw, oneof: "action" },
    { no: 34, name: "position_reward_claim", kind: "message", T: PositionRewardClaim, oneof: "action" },
    { no: 40, name: "delegate", kind: "message", T: Delegate, oneof: "action" },
    { no: 41, name: "undelegate", kind: "message", T: Undelegate, oneof: "action" },
    { no: 42, name: "undelegate_claim", kind: "message", T: UndelegateClaim, oneof: "action" },
    { no: 50, name: "community_pool_spend", kind: "message", T: CommunityPoolSpend, oneof: "action" },
    { no: 51, name: "community_pool_output", kind: "message", T: CommunityPoolOutput, oneof: "action" },
    { no: 52, name: "community_pool_deposit", kind: "message", T: CommunityPoolDeposit, oneof: "action" },
    { no: 53, name: "action_dutch_auction_schedule", kind: "message", T: ActionDutchAuctionSchedule, oneof: "action" },
    { no: 54, name: "action_dutch_auction_end", kind: "message", T: ActionDutchAuctionEnd, oneof: "action" },
    { no: 55, name: "action_dutch_auction_withdraw", kind: "message", T: ActionDutchAuctionWithdraw, oneof: "action" },
    { no: 200, name: "ics20_withdrawal", kind: "message", T: Ics20Withdrawal, oneof: "action" },
  ],
);

/**
 * A transaction perspective is a bundle of key material and commitment openings
 * that allow generating a view of a transaction from that perspective.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionPerspective
 */
export const TransactionPerspective = proto3.makeMessageType(
  "penumbra.core.transaction.v1.TransactionPerspective",
  () => [
    { no: 1, name: "payload_keys", kind: "message", T: PayloadKeyWithCommitment, repeated: true },
    { no: 2, name: "spend_nullifiers", kind: "message", T: NullifierWithNote, repeated: true },
    { no: 3, name: "advice_notes", kind: "message", T: Note, repeated: true },
    { no: 4, name: "address_views", kind: "message", T: AddressView, repeated: true },
    { no: 5, name: "denoms", kind: "message", T: Metadata, repeated: true },
    { no: 6, name: "transaction_id", kind: "message", T: TransactionId },
    { no: 20, name: "prices", kind: "message", T: EstimatedPrice, repeated: true },
    { no: 30, name: "extended_metadata", kind: "message", T: TransactionPerspective_ExtendedMetadataById, repeated: true },
    { no: 40, name: "creation_transaction_ids_by_nullifier", kind: "message", T: TransactionPerspective_CreationTransactionIdByNullifier, repeated: true },
    { no: 50, name: "nullification_transaction_ids_by_commitment", kind: "message", T: TransactionPerspective_NullificationTransactionIdByCommitment, repeated: true },
    { no: 60, name: "batch_swap_output_data", kind: "message", T: BatchSwapOutputData, repeated: true },
  ],
);

/**
 * @generated from message penumbra.core.transaction.v1.TransactionPerspective.ExtendedMetadataById
 */
export const TransactionPerspective_ExtendedMetadataById = proto3.makeMessageType(
  "penumbra.core.transaction.v1.TransactionPerspective.ExtendedMetadataById",
  () => [
    { no: 1, name: "asset_id", kind: "message", T: AssetId },
    { no: 2, name: "extended_metadata", kind: "message", T: Any },
  ],
  {localName: "TransactionPerspective_ExtendedMetadataById"},
);

/**
 * Associates a nullifier with the transaction ID that created the nullified state commitment.
 *
 * Note: this is _not_ the transaction ID that revealed the nullifier.
 *
 * Allows walking backwards from a spend to the transaction that created the note.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionPerspective.CreationTransactionIdByNullifier
 */
export const TransactionPerspective_CreationTransactionIdByNullifier = proto3.makeMessageType(
  "penumbra.core.transaction.v1.TransactionPerspective.CreationTransactionIdByNullifier",
  () => [
    { no: 1, name: "nullifier", kind: "message", T: Nullifier },
    { no: 2, name: "transaction_id", kind: "message", T: TransactionId },
  ],
  {localName: "TransactionPerspective_CreationTransactionIdByNullifier"},
);

/**
 * Associates a commitment with the transaction ID that eventually nullified it.
 *
 * Allows walking forwards from an output to the transaction that spent the note.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionPerspective.NullificationTransactionIdByCommitment
 */
export const TransactionPerspective_NullificationTransactionIdByCommitment = proto3.makeMessageType(
  "penumbra.core.transaction.v1.TransactionPerspective.NullificationTransactionIdByCommitment",
  () => [
    { no: 1, name: "commitment", kind: "message", T: StateCommitment },
    { no: 2, name: "transaction_id", kind: "message", T: TransactionId },
  ],
  {localName: "TransactionPerspective_NullificationTransactionIdByCommitment"},
);

/**
 * @generated from message penumbra.core.transaction.v1.PayloadKeyWithCommitment
 */
export const PayloadKeyWithCommitment = proto3.makeMessageType(
  "penumbra.core.transaction.v1.PayloadKeyWithCommitment",
  () => [
    { no: 1, name: "payload_key", kind: "message", T: PayloadKey },
    { no: 2, name: "commitment", kind: "message", T: StateCommitment },
  ],
);

/**
 * @generated from message penumbra.core.transaction.v1.NullifierWithNote
 */
export const NullifierWithNote = proto3.makeMessageType(
  "penumbra.core.transaction.v1.NullifierWithNote",
  () => [
    { no: 1, name: "nullifier", kind: "message", T: Nullifier },
    { no: 2, name: "note", kind: "message", T: Note },
  ],
);

/**
 * View of a Penumbra transaction.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionView
 */
export const TransactionView = proto3.makeMessageType(
  "penumbra.core.transaction.v1.TransactionView",
  () => [
    { no: 1, name: "body_view", kind: "message", T: TransactionBodyView },
    { no: 2, name: "binding_sig", kind: "message", T: BindingSignature },
    { no: 3, name: "anchor", kind: "message", T: MerkleRoot },
  ],
);

/**
 * @generated from message penumbra.core.transaction.v1.TransactionBodyView
 */
export const TransactionBodyView = proto3.makeMessageType(
  "penumbra.core.transaction.v1.TransactionBodyView",
  () => [
    { no: 1, name: "action_views", kind: "message", T: ActionView, repeated: true },
    { no: 2, name: "transaction_parameters", kind: "message", T: TransactionParameters },
    { no: 4, name: "detection_data", kind: "message", T: DetectionData },
    { no: 5, name: "memo_view", kind: "message", T: MemoView },
  ],
);

/**
 * A view of a specific state change action performed by a transaction.
 *
 * @generated from message penumbra.core.transaction.v1.ActionView
 */
export const ActionView = proto3.makeMessageType(
  "penumbra.core.transaction.v1.ActionView",
  () => [
    { no: 1, name: "spend", kind: "message", T: SpendView, oneof: "action_view" },
    { no: 2, name: "output", kind: "message", T: OutputView, oneof: "action_view" },
    { no: 3, name: "swap", kind: "message", T: SwapView, oneof: "action_view" },
    { no: 4, name: "swap_claim", kind: "message", T: SwapClaimView, oneof: "action_view" },
    { no: 21, name: "delegator_vote", kind: "message", T: DelegatorVoteView, oneof: "action_view" },
    { no: 16, name: "validator_definition", kind: "message", T: ValidatorDefinition, oneof: "action_view" },
    { no: 17, name: "ibc_relay_action", kind: "message", T: IbcRelay, oneof: "action_view" },
    { no: 18, name: "proposal_submit", kind: "message", T: ProposalSubmit, oneof: "action_view" },
    { no: 19, name: "proposal_withdraw", kind: "message", T: ProposalWithdraw, oneof: "action_view" },
    { no: 20, name: "validator_vote", kind: "message", T: ValidatorVote, oneof: "action_view" },
    { no: 22, name: "proposal_deposit_claim", kind: "message", T: ProposalDepositClaim, oneof: "action_view" },
    { no: 30, name: "position_open", kind: "message", T: PositionOpen, oneof: "action_view" },
    { no: 31, name: "position_close", kind: "message", T: PositionClose, oneof: "action_view" },
    { no: 32, name: "position_withdraw", kind: "message", T: PositionWithdraw, oneof: "action_view" },
    { no: 34, name: "position_reward_claim", kind: "message", T: PositionRewardClaim, oneof: "action_view" },
    { no: 41, name: "delegate", kind: "message", T: Delegate, oneof: "action_view" },
    { no: 42, name: "undelegate", kind: "message", T: Undelegate, oneof: "action_view" },
    { no: 50, name: "community_pool_spend", kind: "message", T: CommunityPoolSpend, oneof: "action_view" },
    { no: 51, name: "community_pool_output", kind: "message", T: CommunityPoolOutput, oneof: "action_view" },
    { no: 52, name: "community_pool_deposit", kind: "message", T: CommunityPoolDeposit, oneof: "action_view" },
    { no: 53, name: "action_dutch_auction_schedule", kind: "message", T: ActionDutchAuctionScheduleView, oneof: "action_view" },
    { no: 54, name: "action_dutch_auction_end", kind: "message", T: ActionDutchAuctionEnd, oneof: "action_view" },
    { no: 55, name: "action_dutch_auction_withdraw", kind: "message", T: ActionDutchAuctionWithdrawView, oneof: "action_view" },
    { no: 43, name: "undelegate_claim", kind: "message", T: UndelegateClaim, oneof: "action_view" },
    { no: 200, name: "ics20_withdrawal", kind: "message", T: Ics20Withdrawal, oneof: "action_view" },
  ],
);

/**
 * The data required to authorize a transaction plan.
 *
 * @generated from message penumbra.core.transaction.v1.AuthorizationData
 */
export const AuthorizationData = proto3.makeMessageType(
  "penumbra.core.transaction.v1.AuthorizationData",
  () => [
    { no: 1, name: "effect_hash", kind: "message", T: EffectHash },
    { no: 2, name: "spend_auths", kind: "message", T: SpendAuthSignature, repeated: true },
    { no: 3, name: "delegator_vote_auths", kind: "message", T: SpendAuthSignature, repeated: true },
  ],
);

/**
 * The data required for proving when building a transaction from a plan.
 *
 * @generated from message penumbra.core.transaction.v1.WitnessData
 */
export const WitnessData = proto3.makeMessageType(
  "penumbra.core.transaction.v1.WitnessData",
  () => [
    { no: 1, name: "anchor", kind: "message", T: MerkleRoot },
    { no: 2, name: "state_commitment_proofs", kind: "message", T: StateCommitmentProof, repeated: true },
  ],
);

/**
 * Describes a planned transaction. Permits clients to prepare a transaction
 * prior submission, so that a user can review it prior to authorizing its execution.
 *
 * The `TransactionPlan` is a fully determined bundle binding all of a transaction's effects.
 * The only thing it does not include is the witness data used for proving.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionPlan
 */
export const TransactionPlan = proto3.makeMessageType(
  "penumbra.core.transaction.v1.TransactionPlan",
  () => [
    { no: 1, name: "actions", kind: "message", T: ActionPlan, repeated: true },
    { no: 2, name: "transaction_parameters", kind: "message", T: TransactionParameters },
    { no: 4, name: "detection_data", kind: "message", T: DetectionDataPlan },
    { no: 5, name: "memo", kind: "message", T: MemoPlan },
  ],
);

/**
 * @generated from message penumbra.core.transaction.v1.DetectionDataPlan
 */
export const DetectionDataPlan = proto3.makeMessageType(
  "penumbra.core.transaction.v1.DetectionDataPlan",
  () => [
    { no: 5, name: "clue_plans", kind: "message", T: CluePlan, repeated: true },
  ],
);

/**
 * Describes a planned transaction action.
 *
 * Some transaction Actions don't have any private data and are treated as being plans
 * themselves.
 *
 * @generated from message penumbra.core.transaction.v1.ActionPlan
 */
export const ActionPlan = proto3.makeMessageType(
  "penumbra.core.transaction.v1.ActionPlan",
  () => [
    { no: 1, name: "spend", kind: "message", T: SpendPlan, oneof: "action" },
    { no: 2, name: "output", kind: "message", T: OutputPlan, oneof: "action" },
    { no: 3, name: "swap", kind: "message", T: SwapPlan, oneof: "action" },
    { no: 4, name: "swap_claim", kind: "message", T: SwapClaimPlan, oneof: "action" },
    { no: 16, name: "validator_definition", kind: "message", T: ValidatorDefinition, oneof: "action" },
    { no: 17, name: "ibc_relay_action", kind: "message", T: IbcRelay, oneof: "action" },
    { no: 18, name: "proposal_submit", kind: "message", T: ProposalSubmit, oneof: "action" },
    { no: 19, name: "proposal_withdraw", kind: "message", T: ProposalWithdraw, oneof: "action" },
    { no: 20, name: "validator_vote", kind: "message", T: ValidatorVote, oneof: "action" },
    { no: 21, name: "delegator_vote", kind: "message", T: DelegatorVotePlan, oneof: "action" },
    { no: 22, name: "proposal_deposit_claim", kind: "message", T: ProposalDepositClaim, oneof: "action" },
    { no: 200, name: "ics20_withdrawal", kind: "message", T: Ics20Withdrawal, oneof: "action" },
    { no: 30, name: "position_open", kind: "message", T: PositionOpen, oneof: "action" },
    { no: 31, name: "position_close", kind: "message", T: PositionClose, oneof: "action" },
    { no: 32, name: "position_withdraw", kind: "message", T: PositionWithdrawPlan, oneof: "action" },
    { no: 34, name: "position_reward_claim", kind: "message", T: PositionRewardClaimPlan, oneof: "action" },
    { no: 40, name: "delegate", kind: "message", T: Delegate, oneof: "action" },
    { no: 41, name: "undelegate", kind: "message", T: Undelegate, oneof: "action" },
    { no: 42, name: "undelegate_claim", kind: "message", T: UndelegateClaimPlan, oneof: "action" },
    { no: 50, name: "community_pool_spend", kind: "message", T: CommunityPoolSpend, oneof: "action" },
    { no: 51, name: "community_pool_output", kind: "message", T: CommunityPoolOutput, oneof: "action" },
    { no: 52, name: "community_pool_deposit", kind: "message", T: CommunityPoolDeposit, oneof: "action" },
    { no: 53, name: "action_dutch_auction_schedule", kind: "message", T: ActionDutchAuctionSchedule, oneof: "action" },
    { no: 54, name: "action_dutch_auction_end", kind: "message", T: ActionDutchAuctionEnd, oneof: "action" },
    { no: 55, name: "action_dutch_auction_withdraw", kind: "message", T: ActionDutchAuctionWithdrawPlan, oneof: "action" },
  ],
);

/**
 * Describes a plan for forming a `Clue`.
 *
 * @generated from message penumbra.core.transaction.v1.CluePlan
 */
export const CluePlan = proto3.makeMessageType(
  "penumbra.core.transaction.v1.CluePlan",
  () => [
    { no: 1, name: "address", kind: "message", T: Address },
    { no: 2, name: "rseed", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "precision_bits", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * Describes a plan for forming the transaction memo.
 *
 * @generated from message penumbra.core.transaction.v1.MemoPlan
 */
export const MemoPlan = proto3.makeMessageType(
  "penumbra.core.transaction.v1.MemoPlan",
  () => [
    { no: 1, name: "plaintext", kind: "message", T: MemoPlaintext },
    { no: 2, name: "key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * The encrypted memo data describing information about the purpose of a transaction.
 *
 * @generated from message penumbra.core.transaction.v1.MemoCiphertext
 */
export const MemoCiphertext = proto3.makeMessageType(
  "penumbra.core.transaction.v1.MemoCiphertext",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * The plaintext describing information about the purpose of a transaction.
 *
 * @generated from message penumbra.core.transaction.v1.MemoPlaintext
 */
export const MemoPlaintext = proto3.makeMessageType(
  "penumbra.core.transaction.v1.MemoPlaintext",
  () => [
    { no: 1, name: "return_address", kind: "message", T: Address },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message penumbra.core.transaction.v1.MemoPlaintextView
 */
export const MemoPlaintextView = proto3.makeMessageType(
  "penumbra.core.transaction.v1.MemoPlaintextView",
  () => [
    { no: 1, name: "return_address", kind: "message", T: AddressView },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message penumbra.core.transaction.v1.MemoView
 */
export const MemoView = proto3.makeMessageType(
  "penumbra.core.transaction.v1.MemoView",
  () => [
    { no: 1, name: "visible", kind: "message", T: MemoView_Visible, oneof: "memo_view" },
    { no: 2, name: "opaque", kind: "message", T: MemoView_Opaque, oneof: "memo_view" },
  ],
);

/**
 * @generated from message penumbra.core.transaction.v1.MemoView.Visible
 */
export const MemoView_Visible = proto3.makeMessageType(
  "penumbra.core.transaction.v1.MemoView.Visible",
  () => [
    { no: 1, name: "ciphertext", kind: "message", T: MemoCiphertext },
    { no: 2, name: "plaintext", kind: "message", T: MemoPlaintextView },
  ],
  {localName: "MemoView_Visible"},
);

/**
 * @generated from message penumbra.core.transaction.v1.MemoView.Opaque
 */
export const MemoView_Opaque = proto3.makeMessageType(
  "penumbra.core.transaction.v1.MemoView.Opaque",
  () => [
    { no: 1, name: "ciphertext", kind: "message", T: MemoCiphertext },
  ],
  {localName: "MemoView_Opaque"},
);

